import React, {useEffect} from 'react';
import '../../styles/app/Application.css';
import playStore from '../../assets/images/Application/playStore.png';
import appStore from '../../assets/images/Application/appPlay.png';
import Aos from "aos";
import 'aos/dist/aos.css'
import { useTranslation } from 'react-i18next'

export default function Application(props) {
  const { t } = useTranslation();
  
  useEffect(()=> {
    Aos.init();
  },[])
  return (
    <div className='Application--container'>
        <h1 className='Application-title'>{t('Application.title')} <span className='SpanHighlightBlue'>{t('Application.title_2')}</span> {t('Application.title_3')} :</h1>
        <p className='description'>{t('Application.desc')}</p>
        <div className='Application-image'>
            <a href='/'><img src={playStore} width="200" alt="Play Store"/></a>
            <a href='/'><img src={appStore} width="220" alt="Play Store"/></a>
        </div>
    </div>
  )
}
